import React, { useState, useCallback, useEffect } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { userStatus, errorReason } from '~data/selectors/user'
import { recoverPassword } from '~data/actions/user'

import { Link, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Button, Layout, Text, ButtonRow, Preloader, HeaderTitle as Title, Header } from '~ui';
import { Error } from '~co/overlay/dialog'

export default function PageAccountRecover() {
    const { token } = useParams()
    const dispatch = useDispatch()

    const [password, setPassword] = useState('')
    const status = useSelector(state=>userStatus(state).recover)
    const error = useSelector(state=>errorReason(state).recover)
    const [done, setDone] = useState(false)

    useEffect(()=>{
        if (error)
            Error(error)
    }, [error])

    const onChangePasswordField = useCallback(e=>
        setPassword(e.target.value), []
    )

    const onSubmit = useCallback(e=>{
        e.preventDefault()
        dispatch(recoverPassword({ password, token }, ()=>{
            setDone(true)
        }))
    }, [password, token])

    if (done)
        return (
            <Layout>
                <Header data-fancy>
                    <Title>{t.s('passwordChanged')}</Title>
                </Header>

                <Button
                    as={Link}
                    variant='outline'
                    data-block
                    to='/account/login'>
                    {t.s('signIn')}
                </Button>
            </Layout>
        )

    return (<>
        <Helmet><title>{t.s('changePassword')}</title></Helmet>

        <form onSubmit={onSubmit}>
            <Header data-no-shadow>
                <Title>{t.s('newPassword')}</Title>
            </Header>

            <Layout>
                <Text
                    autoFocus
                    type='password'
                    name='password'
                    disabled={status=='loading'}
                    required
                    value={password}
                    onChange={onChangePasswordField} />

                <ButtonRow>
                    {status == 'loading' ? (
                        <Button variant='flat'>
                            <Preloader />
                        </Button>
                    ) : (
                        <Button
                            as='input' 
                            type='submit'
                            variant='primary'
                            value={t.s('changePassword')} />
                        )}

                    <Button
                        as={Link}
                        variant='outline'
                        to='/account/login'>
                        {t.s('cancel')}
                    </Button>
                </ButtonRow>
            </Layout>
        </form>
    </>)
}